// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/b0d5b71755e3f66a8aff.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"aae74b7e9fa25b99c6ba","172":"3ae29b65101334985dfd","173":"7fd8689469b20b00e44f"}[chunkId] + ".chunk.js";
};